import { TableCell } from "@tiptap/extension-table-cell";

export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      style: {
        default: null,
        parseHTML: (element) => element.getAttribute("style"),
        renderHTML: (attributes) => {
          if (!attributes.style) {
            return {};
          }
          return { style: attributes.style };
        },
      },
      "data-col-id": {
        default: null,
        parseHTML: (element) => element.getAttribute("data-col-id"),
        renderHTML: (attributes) => {
          if (!attributes["data-col-id"]) {
            return {};
          }
          return { "data-col-id": attributes["data-col-id"] };
        },
      },
    };
  },
});
